(function () {
  const fmt = (n) => `\u20C3${Math.round(parseFloat(n) || 0).toLocaleString()}`;

  const render = () => {
    document.querySelectorAll('[data-rental-breakdown]').forEach((root) => {
      if (root.dataset.feesRendered === '1') return;
      const total = root.dataset.rentalTotal;
      const base = root.dataset.rentalBase;
      let fees = [];
      try { fees = JSON.parse(root.dataset.rentalFees || '[]'); } catch (_) {}
      const frag = document.createDocumentFragment();
      const addRow = (label, value, cls = '') => {
        const row = document.createElement('span');
        row.className = 'cart__price__breakdown-row' + (cls ? ' ' + cls : '');
        row.innerHTML = `<span class="cart__price__breakdown-label">${label}</span><span class="cart__price__breakdown-value">${value}</span>`;
        frag.appendChild(row);
      };
      if (total) addRow('Subtotal', total, 'cart__price__breakdown-row--total');
      if (base) addRow('Rental', fmt(base));
      fees.forEach((fee) => addRow(fee.name || 'Fee', fmt(fee.amount)));
      if (!frag.childNodes.length) return;
      root.appendChild(frag);
      root.dataset.feesRendered = '1';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  document.addEventListener('theme:cart:change', render);
  document.addEventListener('cart:update', render);
  document.addEventListener('theme:cart:refresh', render);

  if (typeof MutationObserver === 'function') {
    new MutationObserver(render).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
